import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatTableDataSource, MatSnackBar, MatDatepicker } from '@angular/material';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { Handle } from '../../../handle';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Md5 } from 'ts-md5/dist/md5';
import { LocalSaveService } from 'src/app/services/local-save-service.service';

@Component({
  selector: 'app-create-edificio',
  templateUrl: './create-edificio.component.html',
  styleUrls: ['./create-edificio.component.scss']
})
export class CreateEdificioComponent implements OnInit {

  listaSub = [];
  dataSource;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private localSave: LocalSaveService,
    private dialogRef: MatDialogRef<CreateEdificioComponent>, public Handle: Handle, private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar, private gateway: GatewayService) { }
  operacion = 'createedificio';
  idedificio = '';
  idpais;

  diasSemana = [
    'Lunes', 'Martes', 'Miércoles', 'Jueves',
    'Viernes', 'Sabado', 'Domingo'
  ];
  displayedHorario = ['HORA_INICIAL', 'HORA_FINAL', 'DIA', 'ACCION'];
  listaHorarios = [];
  dataSourceHorario = new MatTableDataSource<any>([]);

  ngOnInit() {
    this.idpais = this.data.edificio.IDPAIS;
    if (this.data.operacion == 'Editar') {
      let SUBS = {
        ID: this.data.edificio.id
      }
      this.operacion = 'editedificio';
      this.idedificio = this.data.edificio.id;
      this.grupoVal.controls.NOMBRE.setValue(this.data.edificio.nombre);
      this.grupoVal.controls.DIRECCION.setValue(this.data.edificio.direccion);

      this.gateway.save('gethorariosedif', SUBS).then((result: any) => {
        this.listaHorarios = result.rows;
        this.dataSourceHorario.data = this.listaHorarios;
      }
      ).catch(function (e) {
      });

    }
  }

  validarHoras(formGroup: FormGroup) {
    const start = formGroup.get('HORA_INICIAL').value;
    const end = formGroup.get('HORA_FINAL').value;

    if (!start || !end) return null;

    // Convertir a minutos para comparar
    const startMin = parseInt(start.replace(':', ''), 10);
    const endMin = parseInt(end.replace(':', ''), 10);

    return startMin < endMin ? null : { horaInvalida: true };
  }

  agregarHorario() {
    if (this.grupoHorario.invalid) return;

    const horaInicial = this.grupoHorario.controls.HORA_INICIAL.value;
    const horaFinal = this.grupoHorario.controls.HORA_FINAL.value;
    const diasSeleccionados: string[] = this.grupoHorario.controls.DIA.value;

    let duplicados = [];

    diasSeleccionados.forEach(dia => {
      const existe = this.listaHorarios.some(h => h.DIA === dia);
      if (existe) {
        duplicados.push(dia);
        return;
      }

      this.listaHorarios.push({
        HORA_INICIAL: horaInicial,
        HORA_FINAL: horaFinal,
        DIA: dia
      });
    });

    if (duplicados.length > 0) {
      this.snackbar.open(
        `Los siguientes días ya tienen horario asignado: ${duplicados.join(', ')}`,
        'Cerrar',
        { duration: 3000 }
      );
    }

    this.dataSourceHorario.data = this.listaHorarios;

    // Limpiar el formulario de horarios
    this.grupoHorario.reset();
  }

  eliminarHorario(index: number) {
    this.listaHorarios.splice(index, 1);
    this.dataSourceHorario.data = this.listaHorarios;
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  save() {
    let md5 = new Md5();
    this.spinner.show();
    let EDIFICIO = {
      ID: this.idedificio,
      NOMBRE: this.grupoVal.controls.NOMBRE.value.trim(),
      DIRECCION: this.grupoVal.controls.DIRECCION.value,
      IDPAIS: this.idpais,
      IDSUPADMIN: this.localSave.get('usuarioPGV').IDU,
      HORARIOS: this.listaHorarios
    }

    // console.log('========')
    //   console.log(this.operacion)
    // console.log(EDIFICIO)
    //   console.log('/=/=======')
    this.gateway.save(this.operacion, EDIFICIO).then((result) => {
      // console.log('========')
      // console.log(result)
      // console.log('/=/=======')
      this.spinner.hide();
      this.dialogRef.close(true);
    }
    ).catch(function (e) {
    });
  }

  grupoVal = new FormGroup({
    NOMBRE: new FormControl('', [Validators.compose([
      Validators.required, Validators.minLength(2), Validators.maxLength(30),
      Validators.pattern("[/ a-z A-Z ñÑáéíóúÁÉÍÓÚ]+[0-9a-z A-Z ñÑáéíóúÁÉÍÓÚ]+")
    ])]),
    DIRECCION: new FormControl('', [])
  });

  grupoHorario = new FormGroup({
    HORA_INICIAL: new FormControl('', Validators.required),
    HORA_FINAL: new FormControl('', Validators.required),
    DIA: new FormControl([], Validators.required)
  }, this.validarHoras);

}
